import { useRef, useEffect } from 'react';
export function usePrevious(value) {
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Return previous value (effect only runs after render)

  return ref.current;
}